import React from "react"
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  UncontrolledDropdown,
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Collapse,
  Spinner
} from "reactstrap"
import {
  Edit,
  Calendar,
  PlusCircle,
  ChevronDown,
  Clipboard,
  Printer,
  Download,
  RotateCw,
  Trash2,
  X
} from "react-feather"
import BarChart from "./components/BarChart"
import classnames from "classnames"
import { inject, observer } from 'mobx-react';
import { withFirebase } from '../../services/Firebase';

@withFirebase
@inject('reportStore', 'sessionStore')
@observer
class ReportsPage extends React.Component {

  async componentDidMount() {
    const { reportStore, firebase, sessionStore } = this.props;
    reportStore.loadData(firebase);
  }


  render() {
    const { reportStore } = this.props;
    const { slideList } = reportStore;

    return (
      <React.Fragment>
          <Col sm="12" md="6">
            <Card>
              <CardHeader>
                <CardTitle>
                  Most Popular Document/Slides
                </CardTitle>
                <div className="actions">
                  <ChevronDown
                    className="collapse-icon mr-50"
                    size={15}
                  />
                </div>
              </CardHeader>
              <CardBody>
                <BarChart slides={slideList} />
              </CardBody>
            </Card>
          </Col>
      </React.Fragment>
    )
  }
}

export default ReportsPage;
